import './index.css';
import RouterApp from './routes/RouterApp';
import useFirebaseUser from './hooks/useFirebaseUser';
import WorkInProgress from './components/WorkInProgress/WorkInProgress';

export default function App() {
  const [user, loading] = useFirebaseUser();

  if (loading === false) {
    return <RouterApp user={user} />
  }
  return null;
}

// const MODO_MANTENIMIENTO = false;

// export default function App() {

//     const [user, loading] = useFirebaseUser();

//   if (MODO_MANTENIMIENTO) {
//     return <WorkInProgress />;
//   }
//   return <RouterApp user={user} />;
// }
